import { useMutation, useQueryClient } from "@tanstack/react-query";

import { API_URL } from "@/constants/envVariables";
import { fetchApi } from "@/helpers/fetchApi";
import { AppError } from "@/types";

export const useMarkNotificationRead = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (notificationId: string) => {
      return fetchApi(`${API_URL}/notifications/${notificationId}/read`, {
        method: "PATCH",
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });

  return {
    ...mutation,
    error: mutation.error as AppError,
    data: mutation.data as { message: string } | undefined,
    mutateAsync: async (notificationId: string) => {
      try {
        await mutation.mutateAsync(notificationId);
      } catch {
        // handled via mutation state
      }
    },
  };
};